<template>
    <div class="meeting">
        <advertising-figure :bannerSrc="bannerSrc" />
        <div class="inner-page-nav">
            <inner-page-nav />
        </div>
        <div class="inner-page-content">
            <public-title :title="title">
                <span class="sub">Arrangement of the meeting</span>
            </public-title>
            <div class="list-wrap">
                <!--zhaowenjin 不需要展示-->
                <!-- <div class="list">
                    <div class="high">
                        <h2 class="tit">接驳安排</h2>
                        <span @click="jumpTo('transhipDetail')">查看详情</span>
                    </div>
                    <span class="time">发布日期: 2022-1-15</span>
                </div> -->
                <div class="list">
                    <div class="high">
                        <h2 class="tit">用餐安排</h2>
                        <span @click="jumpTo('diningDetailPage')">查看详情</span>
                    </div>
                    <span class="time">发布日期: {{ simpleDateFormat(affair.update_time) }}</span>
                </div>
                <div class="list">
                    <div class="high">
                        <h2 class="tit">联系我们</h2>
                        <span @click="jumpTo('linkDetailPage')">查看详情</span>
                    </div>
                    <span class="time">发布日期: {{ simpleDateFormat(affair.update_time) }}</span>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import AdvertisingFigure from "@components/advertising";
    import InnerPageNav from "@components/tool-nav";
    import PublicTitle from "@components/title";
    import { ConfAffairs } from "@/store/entity/conferaffairs"

    export default {
        name: "MeetingDetails",
        components: {
            PublicTitle,
            AdvertisingFigure,
            InnerPageNav,
        },
        data() {
            return {
                bannerSrc: require("@assets/img/meeting-banner.png"),
                title: "会务安排",
                affair: {},
            };
        },
        created() {
            ConfAffairs.get_first().then((result) => {
                this.affair = result
            });
        },
        methods: {
            jumpTo(path) {
                this.$router.push({
                    name: path,
                    params: { "frompage": "affairsList" }
                });
            },
            getInfo() {
                console.log(this.$route.params);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "@assets/scss/innerpagenav.scss";

    .inner-page-nav {
        position: relative;
        width: 1200px;
        height: 60px;
        padding: 0 15px;
        margin: 0 auto;
    }

    .inner-page-content {
        margin: 60px 0;
    }

    .list {
        @include flex-between;
        width: 1200px;
        height: 50px;
        padding: 0 15px;
        margin: 30px auto;
        border-bottom: 1px solid #eee;

        .high {
            height: 100%;

            span {
                font-size: 12px;
                text-align: center;
                color: $defaultColor;
                cursor: pointer;
            }
        }

        .tit {
            position: relative;
            font-size: 18px;
            color: #666;
            font-weight: normal;
            margin-bottom: 5px;
        }

        .time {
            font-size: 14px;
            color: #999;
        }
    }
</style>